import React from "react";
import "scss/steps.css"

export default class StepQuestion extends React.Component{
    render(){
        return <span className={"step_question"}>
            {this.props.children}
        </span>
    }
}